
function animateHamburgerIconOnHover( {target: elHamburger, reverse = false} ){
    
    if( !anime ) return;
    
    if( !elHamburger ) return;

    // Animate svg line paths from right to left
    // const hamburgerAnimation = anime.timeline({
    //     easing: 'easeInOutQuad',
    //     duration: 2500,
    //     autoplay: false,
    //     direction: reverse ? 'reverse' : 'normal'
    // });

    // hamburgerAnimation
    // .add({
    //     targets: '#aw-nav-menu-icon .line-1',
    //     strokeDashoffset: [anime.setDashoffset, 0],
    //     duration: 3500
    // })
    // .add({
    //     targets: '#aw-nav-menu-icon .line-2',
    //     strokeDashoffset: [anime.setDashoffset, 0],
    //     duration: 1500
    // }, '-=500')

}

function animationInit(){

    const elHamburger = document.getElementById('aw-nav-menu-icon');

    elHamburger.addEventListener('mouseenter', () => animateHamburgerIconOnHover( {target: elHamburger} ));
    elHamburger.addEventListener('mouseleave', () => animateHamburgerIconOnHover( {target: elHamburger, reverse: true} ));

}

// Check if loaded event has already fired

// if( document.readyState === 'complete' || document.readyState === 'interactive' ){
//     animationInit();
// }
window.addEventListener('load', animationInit);
